import { render, staticRenderFns } from "./dataBox.vue?vue&type=template&id=20018e64&scoped=true"
import script from "./dataBox.vue?vue&type=script&lang=ts"
export * from "./dataBox.vue?vue&type=script&lang=ts"
import style0 from "./dataBox.vue?vue&type=style&index=0&id=20018e64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20018e64",
  null
  
)

export default component.exports